import { JSONSerializable } from '../../../util/json';
import { Coin } from '../../Coin';
import { Int } from '../../numeric';
import { AccAddress, ValAddress, ValConsPubKey } from '../../strings';

export class MsgCreateValidator extends JSONSerializable<
  MsgCreateValidator.Data
> {
  constructor(
    public description: any,
    public commission: any,
    public min_self_delegation: Int,
    public delegator_address: AccAddress,
    public validator_address: ValAddress,
    public pubkey: ValConsPubKey,
    public value: Coin
  ) {
    super();
  }

  public static fromData(data: MsgCreateValidator.Data): MsgCreateValidator {
    const {
      value: {
        description,
        commission,
        min_self_delegation,
        delegator_address,
        validator_address,
        pubkey,
        value,
      },
    } = data;
    return new MsgCreateValidator(
      description,
      commission,
      new Int(min_self_delegation),
      delegator_address,
      validator_address,
      pubkey,
      Coin.fromData(value)
    );
  }

  public toData(): MsgCreateValidator.Data {
    const {
      description,
      commission,
      min_self_delegation,
      delegator_address,
      validator_address,
      pubkey,
      value,
    } = this;
    return {
      type: 'staking/MsgCreateValidator',
      value: {
        description,
        commission,
        min_self_delegation: min_self_delegation.toString(),
        delegator_address,
        validator_address,
        pubkey,
        value: value.toData(),
      },
    };
  }
}

export namespace MsgCreateValidator {
  export interface Data {
    type: 'staking/MsgCreateValidator';
    value: {
      description: any; // TODO: replace with Description
      commission: any; // TODO: replace with CommissionRates
      min_self_delegation: string;
      delegator_address: AccAddress;
      validator_address: ValAddress;
      pubkey: ValConsPubKey;
      value: Coin.Data;
    };
  }
}
